import { render, staticRenderFns } from "./GroupCustomFieldRow.vue?vue&type=template&id=2985d1ac&scoped=true&"
import script from "./GroupCustomFieldRow.vue?vue&type=script&lang=js&"
export * from "./GroupCustomFieldRow.vue?vue&type=script&lang=js&"
import style0 from "./GroupCustomFieldRow.vue?vue&type=style&index=0&id=2985d1ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2985d1ac",
  null
  
)

export default component.exports